import React from "react";
import { Route, Routes } from "react-router-dom";
import {  Login } from "./containers";

export const Authentication = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
      </Routes>
    </>
  );
};
